import { httpMethods } from 'enums';
import { Http } from 'library';
import api from '../../../api/client';
import * as Endpoints from '../../../constants/endpoints.constant';;
 
interface DeliveryOrderFilters {
  metalCode?: string;
  fromDate?: string;
  toDate?: string;
}
 
class DeliveryOrdersServices {
  async getDeliverOrders(filters: DeliveryOrderFilters = {}, page: number) {
    let query = `&isPaginated=true&pageSize=10&page=${page}`;

    if (filters?.metalCode) query += `&metalCode=${filters?.metalCode}`;
    if (filters?.fromDate) query += `&fromDate=${filters?.fromDate}`;
    if (filters?.toDate) query += `&toDate=${filters?.toDate}`;
 
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.DELIVERY_ORDER_LIST}?${query}`)
      .setToken(api.getToken())
      .request();
  }
 
 
    async downloadDeliveryInvoice(gstInvoiceRef, userId) {
      return await Http.setMethod(httpMethods.get)
        .unsetData()
        .setUrl(`${Endpoints.DELIVERY_INVOICE_PDF}/${encodeURIComponent(gstInvoiceRef)}?user_id=${userId}`)
        .setToken(api.getToken())
        .request();
    }

     async verifyBar(certificateNo){
      return await Http.setMethod(httpMethods.get)
        .unsetData()
        .setUrl(`${Endpoints.DELIVERY_BAR_VERIFY}?certiNo=${certificateNo}`)
        .setToken(api.getToken())
        .request();
    }
  
}
 
export default new DeliveryOrdersServices();